import { StatesEnum } from "@/models/state_enum";

export class StateUtils {
  static formatNameForSearch(input: string) {
    const cleanedInput = input
      .toUpperCase()
      .replace(/STATE OF/i, "")
      .trim();
    return this.formatCompare(cleanedInput);
  }

  static getStateCode(stateName: string): string | undefined {
    const stateCode = (
      Object.keys(StatesEnum) as Array<keyof typeof StatesEnum>
    ).find((key) => StatesEnum[key] === stateName);
    return stateCode;
  }

  static getStateIndex(stateName: string): number | undefined {
    const entries = Object.entries(StatesEnum);
    for (let index = 0; index < entries.length; index++) {
      if (this.formatCompare(entries[index][1].toUpperCase()) === stateName) {
        return index;
      }
    }
    return undefined;
  }

  static formatCompare(text: string): string {
    let formatted = text.toUpperCase();
    formatted = formatted.replace(/[ÁÃ]/g, "A");
    formatted = formatted.replace(/[ÊÉ]/g, "E");
    formatted = formatted.replace(/[ÎÍ]/g, "I");
    formatted = formatted.replace(/[ÔÓ]/g, "O");
    formatted = formatted.replace(/[ÛÚ]/g, "U");
    return formatted;
  }
}
